// import * as React, from "react";
import React, { useEffect, useState, useRef } from "react";

// React Bootstrap
import { Modal, Tab, Nav, Offcanvas } from 'react-bootstrap';


// Import Slider

// Import Components

// Import Images
import logoWhite from '../assets/images/logo-white.svg'
import bannerBgImg from '../assets/images/crypto-banner-img-dektop.png'
import bannerBgImgMobile from '../assets/images/crypto-banner-img-mobile.png'
import bannerBgMobileImg from '../assets/images/landing-banner-bg-mobile-img.png'
import custodianWalletImg from '../assets/images/custodian-wallet-img.svg'
import hardwareWalletImg from '../assets/images/hardware-wallet-img.svg'
import mobileWalletImg from '../assets/images/mobile-wallet-img.svg'
import isoLogoImg from '../assets/images/iso-logo-img.png'
import fiatLogoImg from '../assets/images/fiat-logo-img.png'
import securityImg from '../assets/images/security-img.png'
import footerBgImg from '../assets/images/footer-bg-img.png'
import footerBgMobileImg from '../assets/images/footer-bg-mobile-img.png'

import tradingDeskImg1 from '../assets/images/trading-desk-img-1.png'
import tradingDeskImg2 from '../assets/images/trading-desk-img-2.png'
import cryptoGlobalImg from '../assets/images/crypto-global-img.png'
import linkedinGrayIcon from '../assets/images/icons/linkedin-light-gray-icon.svg'
import youtubeGrayIcon from '../assets/images/icons/youtube-light-gray-icon.svg'
import xGrayIcon from '../assets/images/icons/x-light-gray-icon.svg'

// Import Icons
import offerIcon from "../assets/images/icons/offer-black-icon.svg";
import menuBarIcon from "../assets/images/icons/hamburger-menu-white.svg";
import Google from './auth/Clientlogin/Google';


function CryptoLegal() {
    const [openMenu, setOpenMenu] = useState(false);
    const [user, setUser] = useState(null);
    const [showLogin, setShowLogin] = useState(false);

    useEffect(() => {
        document.body.classList.add("landing-page-body");
        // Cleanup: Remove the class when the component unmounts or route changes
        return () => {
            document.body.classList.remove("landing-page-body");
        };
    });

    const toggleMenu = () => {
        setOpenMenu(prev => !prev);
    };

    useEffect(() => {
        const s = sessionStorage.getItem("logedinUser");
        if (s) {
            try {
                setUser(JSON.parse(s));
            } catch {
                setUser(null);
            }
        }
    }, []);

    const openLoginModal = (e) => {
        e.preventDefault();
        setShowLogin(true);
    };

    const closeLoginModal = () => {
        setShowLogin(false);
    };

    const logout = (e) => {
        e.preventDefault();
        sessionStorage.clear();
        setUser(null);
    };


    return (
        <div className='home-page'>

            <div className={`landing-header ${openMenu ? 'menu-open' : ''}`}>
                <div className="header-wrapper">
                    <div className="logo-wrapper">
                        <a href="#" className="logo">
                            <img src={logoWhite} alt="logo" />
                        </a>
                    </div>
                    <div className="navbar-menu">
                        <div className="menu-bar">
                            <img src={menuBarIcon} onClick={toggleMenu} alt="icon" />
                        </div>
                        <ul className={`menu ${openMenu ? 'active' : ''}`}>
                            {user ? (<>
                                <li><a href="/home-page">Custodian</a></li>
                                <li><a href="/otc-trade">Crypto On/Off Ramp</a></li>
                                <li><a href="#" onClick={logout}>Log Out</a></li>
                                <li><a href="#">Schedule a Demo</a></li>
                                <li>
                                    <div className="dropdown-v1">
                                        <Nav>
                                            <Nav.Item>
                                                <img width="40px" height="40px" src={user.picture} alt="User profile" />
                                            </Nav.Item>
                                        </Nav>
                                    </div>
                                </li>
                            </>
                            ) : (<>
                                <li><a href="#" onClick={openLoginModal}>Custodian</a></li>
                                <li><a href="#" onClick={openLoginModal}>Crypto On/Off Ramp</a></li>
                                <li><a href="#" onClick={openLoginModal}>Log In</a></li>
                                <li><a href="#">Schedule a Demo</a></li>
                            </>
                            )}
                        </ul>
                    </div>
                </div>
            </div>

            <Offcanvas show={showLogin} onHide={closeLoginModal} placement="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Log In</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <ul className="btn-list">
                        <Google />
                    </ul>
                </Offcanvas.Body>
            </Offcanvas>

            <section className="sec-empty-banner">
                <div className="container-fluid">
                </div>
            </section>

            <section className="sec-crypto-legal">
                <div className="container p-lr-40">
                    <div className="legal-card">
                        <h2 className="title-style-01">Website Terms of Services</h2>
                        <ul className="legal-list">
                            <li>By accessing or using DORU.CO, you agree to our Terms of Service. <br />
                                DORU.CO provides secure custodian wallet, air-gapped hardware, and mobile wallet solutions for digital assets under Swiss regulatory standards.</li>
                            <li>All services are offered strictly in compliance with applicable AML/KYC and Swiss financial regulations. <br />
                                You must use this platform lawfully and in accordance with these Terms.</li>
                            <li>We do not provide investment, financial, or trading advice. <br />
                                All platform content and materials are the property of DORU.CO and may not be reproduced without permission.</li>
                            <li>Use of this website is at your own risk. DORU.CO is not liable for any losses arising from the use or inability to access the site or wallet interfaces.</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="sec-crypto-legal">
                <div className="container p-lr-40">
                    <div className="legal-card">
                        <h2 className="title-style-01">Privacy Policy</h2>
                        <ul className="legal-list">
                            <li>We respect your privacy and protect your data in accordance with Swiss Data Protection Law and GDPR.</li>
                            <li>Personal information (e.g., name, email, verification data) is collected solely to operate our custody, wallet, and OTC services.<br />
                                Your data is stored on secure, air-gapped systems and never shared or sold to third parties.</li>
                            <li>You may request access, correction, or deletion of your data by contacting [Insert Contact Email]. <br />
                                We may use cookies for performance and security purposes.</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="sec-crypto-legal">
                <div className="container p-lr-40">
                    <div className="legal-card">
                        <h2 className="title-style-01">Disclaimer</h2>
                        <ul className="legal-list">
                            <li>DORU.CO provides secure, offline, air-gapped wallet infrastructure for digital asset custody and conversions.</li>
                            <li>While we employ institutional-grade safeguards, digital asset storage and trading carry inherent risks, including market volatility and potential third-party breaches. <br />
                                DORU.CO makes no guarantees regarding future performance or asset value.</li>
                            <li>All operations comply with Swiss financial and data security standards.</li>
                        </ul>
                    </div>
                </div>
            </section>

            <div className="crypto-landing-footer">
                <img src={footerBgImg} alt="img" className="bg-img d-none d-md-block" />
                <img src={footerBgMobileImg} alt="img" className="bg-img d-block d-md-none" />
                <div className="container">
                    <div className="content-wrapper">
                        <ul className="link-list">
                            <li><a href="#">Crypto On/Off Ramp</a></li>
                            {!user && <li><a href="#">Log In</a></li>}
                            <li><a href="#">Schedule a Demo</a></li>
                            <li><a href="#">Partnership Opportunity</a></li>
                            <li><a href="#">About Doru</a></li>
                            <li><a href="#">FAQ</a></li>
                        </ul>
                        <ul className="link-list">
                            <li><a href="#">Legal</a></li>
                            <li><a href="#">Website Terms of Service</a></li>
                            <li><a href="#">Privacy Policy</a></li>
                            <li><a href="#">Disclaimer</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* <div className="crypto-landing-bottom-footer">
                <div className="container">
                    <div className="content-wrapper">
                        <p className="p">Products developed in the XDC Innovation Lab.</p>
                        <ul className="social-list">
                            <li><a href="#" target="_blank"><img src={linkedinGrayIcon} alt="icon" /></a></li>
                            <li><a href="#" target="_blank"><img src={youtubeGrayIcon} alt="icon" /></a></li>
                            <li><a href="#" target="_blank"><img src={xGrayIcon} alt="icon" /></a></li>
                        </ul>
                    </div>
                </div>
            </div> */}
        </div>
    )
}

export default CryptoLegal
